console.log('default');

class Master {
  constructor() {
    this.init();
  }

  init() {
    this.initBindings();
  }

  initBindings() {
    jjl('.level3-label').on('click', (e) => {
      jjl('#side-navigation').addClass('level3');
    });

    jjl('.level2-label').on('click', (e) => {
      jjl('#side-navigation').removeClass('level3');
      document.querySelectorAll('.level3-input').forEach((checkbox) => {
        checkbox.checked = false;
      });
    });

    jjl('.menu-toggle').on('click', (e) => {
      jjl('#side-navigation').removeClass('level3');
      document
        .querySelectorAll('.level2-input, .level3-input')
        .forEach((checkbox) => {
          checkbox.checked = false;
        });
    });

    jjl('.menu-back').on('click', (e) => {
      jjl('#side-navigation').removeClass('level3');
      document.querySelectorAll('.level3-input').forEach((checkbox) => {
        checkbox.checked = false;
      });
    });

    jjl('#side-menu-switch').on('change', (e) => {});

    jjl('.toggle-message').on('click', (e) => {
      var toggle = e.currentTarget.dataset.toggle;
      var popup = jjl('[data-popup=' + toggle + ']')[0];

      popup.classList.toggle('active');
      document.getElementsByTagName('body')[0].classList.toggle('modal-active');
    });

    const items = document.querySelectorAll('.sub-nav .sub-menu li');
    for (const item of items) {
      item.addEventListener('click', function handleClick(event) {
        const currentActiveItem = document.querySelectorAll(
          '.sub-nav ul.sub-menu .active'
        );
        if (currentActiveItem.length > 0) {
          currentActiveItem[0].classList.remove('active');
          currentActiveItem[1].classList.remove('active');
          item.querySelector('span').classList.add('active');
          item.querySelector('svg').classList.add('active');
        }
        item.querySelector('span').classList.add('active');
        item.querySelector('svg').classList.add('active');
        console.log(event.target);
      });
    }


  }
}

function fullWidth() {
  var elem = document.getElementById('map-container');
  elem.querySelector('.container').classList.toggle('fluid');
}

function reverseOrder() {
  var elem = document.getElementById('map-container');
  elem.querySelector('.row').classList.toggle('reverse');
}

function checkMenuState(checkbox) {
  var menuSwitch = document.getElementById('side-menu-switch');

  if (menuSwitch.checked != true) {
    menuSwitch.checked = true;
  }
}

// jjl.ready(() => {
//   fetch('header.html')
//     .then((response) => {
//       return response.text();
//     })
//     .then((data) => {
//       document.querySelector('header').innerHTML = data;

//       /*fire event so a listner can pick up when the html is added to the page and can bind events to the inserted html */
//       const event = new Event('headerLoaded');
//       document.dispatchEvent(event);

//       window.master = new Master();
//     });

//   fetch('footer.html')
//     .then((response) => {
//       return response.text();
//     })
//     .then((data) => {
//       document.querySelector('footer').innerHTML = data;
//     });

//   // window.master = new Master();
// });
